'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtAddressBox', [
	function () {
		return {
			restrict: 'A',
			replace: true,
			scope: {
				pmtAddressBox: '@',
				diffObject: '='
			},
			link: function (scope, element, attrs) {
				scope.stringify = function (obj) {
					return JSON.stringify(obj);
				};
				attrs.$observe(
					'pmtAddressBox',
					function (newVal) {
						scope.address = scope.$eval(newVal);
					},
					true
				);
			},
			templateUrl: 'directive-templates/pmtAddressBox.html'
		};
	}
]);
